var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftDrinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26336 26.4428V19.6668C5.89453 19.2812 3.9251 18.1794 2.35506 16.3615C0.785019 14.5435 0 12.395 0 9.91604V1.65267C0 1.18442 0.158381 0.791906 0.475143 0.475143C0.791906 0.158381 1.18442 0 1.65267 0H18.1794C18.6477 0 19.0402 0.158381 19.3569 0.475143C19.6737 0.791906 19.8321 1.18442 19.8321 1.65267V9.91604C19.8321 12.395 19.0471 14.5435 17.477 16.3615C15.907 18.1794 13.9375 19.2812 11.5687 19.6668V26.4428H14.8741C15.3423 26.4428 15.7348 26.6011 16.0516 26.9179C16.3683 27.2347 16.5267 27.6272 16.5267 28.0954C16.5267 28.5637 16.3683 28.9562 16.0516 29.273C15.7348 29.5897 15.3423 29.7481 14.8741 29.7481H4.95802C4.48976 29.7481 4.09725 29.5897 3.78049 29.273C3.46373 28.9562 3.30535 28.5637 3.30535 28.0954C3.30535 27.6272 3.46373 27.2347 3.78049 26.9179C4.09725 26.6011 4.48976 26.4428 4.95802 26.4428H8.26336ZM9.91604 16.5267C11.4585 16.5267 12.8082 16.0585 13.9651 15.122C15.122 14.1854 15.8932 13.001 16.2788 11.5687H3.55325C3.93887 13.001 4.71012 14.1854 5.86699 15.122C7.02386 16.0585 8.37354 16.5267 9.91604 16.5267ZM3.30535 8.26336H16.5267V3.30535H3.30535V8.26336Z",
    fill: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftDrinks);
export default __webpack_public_path__ + "static/media/soft-drinks.f6d0f2435264258ce5dbf9f8638a99c0.svg";
export { ForwardRef as ReactComponent };